exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".App {\n  text-align: center;\n  margin: 2em;\n  padding: 2em;\n}\n\n.blue-background {\n  background-color: #f0f0f0 !important;\n}\n\n.blue-background-dark {\n    background-color: aliceblue !important;\n}\n\n.col-centered {\n  float: none;\n  margin: 0 auto;\n}\n\n.row-margin-20 {\n  margin-top: 20px;\n}\n\n.row-margin-10 {\n  margin-top: 10px;\n}\n\n.pad-10 {\n  padding: 10px;\n}\n", ""]);

// exports
